import React, { useState } from 'react';
import { Box, Paper, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import RawStockForm from '../../components/transaction/RawStockForm';
import RawStockTable from '../../components/transaction/RawStockTable';

const RawStockPage = () => {
  const [selectedRawStock, setSelectedRawStock] = useState(null);

  const handleEdit = (rawStock) => {
    setSelectedRawStock(rawStock);
  };

  const handleFormReset = () => {
    setSelectedRawStock(null);
  };

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Button
          component={Link}
          to="/activity-log"
          variant="contained"
          color="primary"
        >
          View Activity Log
        </Button>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'flex-start',
          width: '100%',
          flexWrap: { xs: 'wrap', md: 'nowrap' },
          p: 2,
        }}
      >
        {/* Table - Left Side */}
        <Paper
          elevation={3}
          sx={{
            flex: 2,
            p: 2,
            minWidth: 0,
          }}
        >
          <RawStockTable onEdit={handleEdit} />
        </Paper>

        {/* Form - Right Side */}
        <Paper
          elevation={3}
          sx={{
            flex: 1,
            p: 2,
            minWidth: 300,
          }}
        >
          <RawStockForm
            selectedRawStock={selectedRawStock}
            onReset={handleFormReset}
          />
        </Paper>
      </Box>
    </>
  );
};

export default RawStockPage; 